import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import ReactLoading from 'react-loading';

const State = {
  Initialized: 0,
  Downloading: 1,
  Downloaded: 2,
  Cancelled: 3
}

class SoapDownloader2 extends Component {

  constructor() {
    super();

    this.downloadLinkRef = React.createRef();
    this.load = this.load.bind(this);

    this.state = {
      fileUrl: null,
      value: null,
      state: State.Cancelled
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate() {
    this.load();
  }

  load() {
    if (this.state.state === State.Initialized) {
      this.setState({
        state: State.Downloading
      }, () => {
        this.props.value
          .then(result => {
            let blob = new Blob( [ result.content ], { type: "octet/stream" } );
            let urlCreator = window.URL || window.webkitURL;
            var url = urlCreator.createObjectURL(blob);
            this.setState({
              fileUrl: url,
              fileName: result.name
            }, () => {
              this.downloadLinkRef.current.click();
              urlCreator.revokeObjectURL(url);
              this.props.toggle && this.props.toggle();
              this.setState({state: State.Downloaded});
            });
          });
      });
    }
  }

  render() {
    return (
        <>
          {this.state.fileUrl && (
              <Modal isOpen={this.props.value !== null} size="lg">
                <ModalHeader className="justify-content-center" toggle={this.props.toggle}>
                  {this.props.name}
                </ModalHeader>
                <ModalBody style={{ padding: "0", height: "500px" }}>
                  {!this.state.fileUrl && (
                      <ReactLoading
                          type="spinningBubbles"
                          style={{ width: "200px", height: "200px", margin: "150px auto 0 auto", fill: "#888" }}
                      />
                  )}
                  {this.state.fileUrl && (
                      <a ref={this.downloadLinkRef} style={{ display: 'none' }} href={this.state.fileUrl} download={this.state.fileName} />
                  )}
                </ModalBody>
              </Modal>
          )}
        </>
    );
  }


  static getDerivedStateFromProps(nextProps, prevState) {

    if (!nextProps.value) {
      return {
        state: State.Cancelled
      }
    }

    if (nextProps.valueKey !== prevState.valueKey) {
      return {
        valueKey: nextProps.valueKey,
        fileUrl: null,
        state: State.Initialized
      }
    }

    return null;
  }
}

export default SoapDownloader2;
